// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CampaignPromotionModal_wrapper__TaxRU","modalBody":"CampaignPromotionModal_modalBody__1GxPr"};